"use strict";
/*
 * Created on 03 05 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * A reason why an item (product, site, sellout type) stopped being identified for sellout. Origins from an external system handling sellout
 * identification.
 *
 * @author Jaroslav Sevcik
 */


var SelloutEndReason =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutEndReason, _DomainObject_1$Domai);

  /**
   * @param id Internal ID
   * @param externalId Numerical ID of the reason from an external system
   * @param description The reason explanation
   */
  function SelloutEndReason(id, externalId, description) {
    var _this;

    _classCallCheck(this, SelloutEndReason);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutEndReason).call(this));
    _this.id = id;
    _this.externalId = externalId;
    _this.description = description;
    return _this;
  }

  return SelloutEndReason;
}(DomainObject_1.DomainObject);

exports.SelloutEndReason = SelloutEndReason;